// extracted by mini-css-extract-plugin
module.exports = {"container":"_38RRnYTMN5GZjlWsCo3i3l","banner":"m1rbveRxWOMPJuDBzJ4kD","text":"QLk3qFJ48z0oF8nmDyj38","ingress":"_1ealHfkxTybTXDiQRa1A-E","cta":"_1c_v1NYaz0QhU1VdnhtR9E"};